import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { useProfileEmail, usePublicProfile, useTrackPublicProfileEmail } from "@seabrookstudios/pitch2table";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material";
import { ExternalLink } from "../styleguide/AppLink";
import { useIsOwnContent } from "./useIsDesigner";

/**
 * @param {object} props
 * @param {string} props.username
 * @param {string} [props.subject]
 */
const FetchEmail = ({ username, subject }) => {
  const { data: email, isPending } = useProfileEmail(username);
  const track = useTrackPublicProfileEmail(username);
  const isOwnContent = useIsOwnContent(username);

  useEffect(() => {
    // Only track if not viewing own profile email
    // isOwnContent is null when not authenticated or loading, false when authenticated but not owner, true when owner
    if (isOwnContent !== true) {
      track.mutateAsync();
    }
  }, [isOwnContent, track]);

  return isPending ? (
    <Skeleton />
  ) : (
    <ExternalLink href={`mailto:${email}${subject ? `?subject=${subject}` : ""}`}>{email}</ExternalLink>
  );
};

/**
 * @param {object} props
 * @param {string} props.username
 */
export const ClickToRevealEmail = ({ username }) => {
  const theme = useTheme();
  const [show, setShow] = useState(false);

  const reveal = () => {
    setShow(true);
  };

  return !show ? (
    <Typography onClick={reveal} color={theme.palette.primary.light}>
      Click to reveal
    </Typography>
  ) : (
    <FetchEmail username={username} />
  );
};

/**
 * @param {object} props
 * @param {string} props.username
 * @param {string} [props.subject]
 */
export const ClickToRevealEmailButton = ({ username, subject }) => {
  const { data: profile } = usePublicProfile(username);

  const [show, setShow] = useState(false);

  const reveal = () => {
    setShow(true);
  };

  if (!profile) {
    return <Skeleton />;
  }

  if (!profile.showEmail) {
    return null;
  }

  return !show ? (
    <Button onClick={reveal} variant="outlined">
      Click to reveal designer email
    </Button>
  ) : (
    <FetchEmail username={username} subject={subject} />
  );
};
